import React from 'react';
import { isMobile } from '@pascal/pascal-core';

import { marketsParser } from '../../../helpers';
import { globalTranslationKeys } from '../../../enums';
import chest from '../../../assets/images/empty-chest.png';

export const GameSpecificCheckHashPopupTopSection = ({ t, currentData, isFromBetHistory }) => {
  return (
    <div className='m-dice-result-wrp'>
      {isFromBetHistory && (
        <div className='bet-type-wrp-holder'>
          <div className='bet-type-wrp'>
            <div className='bet-type-item big-item'>
              <p className='bet-type-item-txt'>{t('BET_TYPE')}</p>
            </div>
            {currentData.additionalParams?.length &&
              currentData.additionalParams.map((item, index) => (
                <div className='bet-type-item' key={index}>
                  <p className='bet-type-item-num'>{marketsParser([item])}</p>
                </div>
              ))}
          </div>
        </div>
      )}
      <div className='m-dice-result-bottom-holder'>
        <span className='result-count-num'>{currentData?.roundData?.reduce((item, acc) => item + acc, 0) || null}</span>
        <div className='dice-holder'>
          {currentData.roundData &&
            currentData.roundData.map((item, index) => <div key={index} className={`dice-item dice-${item}`} />)}
        </div>
        <div className='empty-chest'>
          <img src={chest} alt='' />
        </div>
      </div>
    </div>
  );
};

export const AboutHashInnerContent = ({ t }) => {
  return (
    <>
      {isMobile() && <p className='pr-f-text'>{t(globalTranslationKeys.PROVABLY_FAIRNESS)}</p>}
      <p className='pr-f-text'>{t('FAIRNESS_P1')}</p>
      <p className='pr-f-text w-b-ba'>
        8860731B4F9523DD3A1AA686A237BB89CC5EC01448ADFFE6FFE64F12E3015C648904D3761689EA0B642B8E0A8A250ADA0773247B792541B2EE4FD89EFFA3283B
      </p>
      <p className='pr-f-text'>{t('FAIRNESS_P2')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P3')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P4')}</p>
      <ol className='pr-f-text'>
        <li className='pr-f-text'>{t('FAIRNESS_P5')}</li>
        <li className='pr-f-text'>{t('FAIRNESS_P6')}</li>
        <li className='pr-f-text'>{t('FAIRNESS_P7')}</li>
        <li className='pr-f-text'>{t('FAIRNESS_P8')}</li>
      </ol>
      <p className='pr-f-text'>{t('FAIRNESS_P9')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P10')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P11')}</p>
      <p className='pr-f-text w-b-ba'>
        8860731B4F9523DD3A1AA686A237BB89CC5EC01448ADFFE6FFE64F12E3015C648904D3761689EA0B642B8E0A8A250ADA0773247B792541B2EE4FD89EFFA3283B
      </p>
      <p className='pr-f-text' key={Date.now()}>
        {t('FAIRNESS_P12')}
      </p>
    </>
  );
};

export const HelpPopupInnerContent = ({ t }) => {
  return (
    <>
      <p>{t('GAME_RULES_P1')}</p>
      <p>{t('GAME_RULES_P2')}</p>
      <p>{t('GAME_RULES_P3')}</p>
      <p>{t('GAME_RULES_P4')}</p>
      <p>{t('GAME_RULES_P5')}</p>
      <div className='range-item item-4' />
      <p>{t('GAME_RULES_P6')}</p>
      <p>{t('GAME_RULES_P7')}</p>
      <div className='range-item item-1' />
      <p>{t('GAME_RULES_P8')}</p>
      <p>{t('GAME_RULES_P9')}</p>
      <div className='range-item item-3' />
      <p>{t('GAME_RULES_P10')}</p>
      <p>{t('GAME_RULES_P11')}</p>
      <div className='range-item item-2' />
      <p>{t('GAME_RULES_P12')}</p>
      <p>{t('GAME_RULES_P13')}</p>
      <p>
        {t(globalTranslationKeys.CancelationMessage1)}
        <br />
        {t(globalTranslationKeys.MalfunctionMessage2)}
      </p>
      <p>{t(globalTranslationKeys.Rtp)}</p>
    </>
  );
};
